// Título de sección: grande y con una línea fina que lo separa del bloque anterior (salvo el primero).
export function HeadingSection({ section }) {
  return (
    <h3
      data-testid="typed-section-heading"
      className="text-xl md:text-2xl font-semibold tracking-tight text-foreground mt-7 mb-2 pt-5 border-t border-border first:mt-2 first:pt-0 first:border-t-0"
    >
      {section.text}
    </h3>
  );
}
